import React, { useState } from "react";

import { Table, Divider, Button, Tag, Space, Switch, Row, Select } from "antd";

import { DownloadOutlined } from "@ant-design/icons";

import { LAYOUT_REPORT_EXPORT_NEW } from "../../navigation";

import BasicList from "../../../../core/components/list";
import DateTime from "../../../../core/components/datetime";
import { basicDeleteActionField } from "../../../../components/table/fields/common";

import { configureSort } from "../../../../core/utils/list";

import { _filter } from "../../../../core/components/form";

import { DATE_FORMAT, DATE_DDMMYYYY } from "../../../../core/utils/i18n-js";
import Moment from "moment";

import {
    CRON_REPORT_SUBTYPES,
    CRON_REPORT_SUBTYPE_CLIENT,
    CRON_REPORT_SUBTYPE_VENDOR,
    CRON_REPORT_SUBTYPE_JOB,
    CRON_REPORT_SUBTYPE_PURCHASE_ORDER,
    CRON_REPORT_SUBTYPE_INVOICE,
    CRON_REPORT_SUBTYPE_PAYMENT,
    CRON_REPORT_SUBTYPE_QA,
} from "../../const";

const { Option } = Select;

const qaParameters = (parameters) => {
    if (Object.keys(parameters).length === 0) {
        return <b>No filters</b>;
    }
    return (
        <>
            {parameters.from != undefined && (
                <>
                    <b>From: </b> {Moment(parameters.from, DATE_DDMMYYYY).format(DATE_FORMAT)} <br />{" "}
                </>
            )}
            {parameters.to != undefined && (
                <>
                    <b>To: </b> {Moment(parameters.to, DATE_DDMMYYYY).format(DATE_FORMAT)} <br />{" "}
                </>
            )}
            {parameters.vendor != undefined && (
                <>
                    <b>Vendor:</b> {parameters.vendor != "0" ? parameters.vendorName : "All"} <br />
                </>
            )}
        </>
    );
};

const invoiceParameters = (parameters) => {
    if (Object.keys(parameters).length === 0) {
        return <b>No filters</b>;
    }
    return (
        <>
            {parameters.from != undefined && (
                <>
                    <b>From: </b> {Moment(parameters.from, DATE_DDMMYYYY).format(DATE_FORMAT)} <br />{" "}
                </>
            )}
            {parameters.to != undefined && (
                <>
                    <b>To: </b> {Moment(parameters.to, DATE_DDMMYYYY).format(DATE_FORMAT)} <br />{" "}
                </>
            )}
            {parameters.vendor != undefined && (
                <>
                    <b>Vendor:</b> {parameters.vendor != "0" ? parameters.vendorName : "All"} <br />
                </>
            )}

            {parameters.status != undefined && (
                <>
                    <b>Status:</b>
                    <ul>
                        {parameters.status.map((i) => (
                            <li>{i}</li>
                        ))}
                    </ul>
                </>
            )}
        </>
    );
};

const paymentParameters = (parameters) => {
    if (Object.keys(parameters).length === 0) {
        return <b>No filters</b>;
    }
    return (
        <>
            {parameters.from != undefined && (
                <>
                    <b>From: </b> {Moment(parameters.from, DATE_DDMMYYYY).format(DATE_FORMAT)} <br />{" "}
                </>
            )}
            {parameters.to != undefined && (
                <>
                    <b>To: </b> {Moment(parameters.to, DATE_DDMMYYYY).format(DATE_FORMAT)} <br />{" "}
                </>
            )}
            {parameters.vendor != undefined && (
                <>
                    <b>Vendor:</b> {parameters.vendor != "0" ? parameters.vendorName : "All"} <br />
                </>
            )}
        </>
    );
};

const purchaseOrderParameters = (parameters) => {
    if (Object.keys(parameters).length === 0) {
        return <b>No filters</b>;
    }
    return (
        <>
            {parameters.from != undefined && (
                <>
                    <b>From: </b> {Moment(parameters.from, DATE_DDMMYYYY).format(DATE_FORMAT)} <br />{" "}
                </>
            )}
            {parameters.to != undefined && (
                <>
                    <b>To: </b> {Moment(parameters.to, DATE_DDMMYYYY).format(DATE_FORMAT)} <br />{" "}
                </>
            )}
            {parameters.vendor != undefined && (
                <>
                    <b>Vendor:</b> {parameters.vendor != "0" ? parameters.vendorName : "All"} <br />
                </>
            )}

            {parameters.status != undefined && (
                <>
                    <b>Status:</b>
                    <ul>
                        {parameters.status.map((i) => (
                            <li>{i}</li>
                        ))}
                    </ul>
                </>
            )}
        </>
    );
};

const vendorParameters = (parameters) => {
    if (Object.keys(parameters).length === 0) {
        return <b>No filters</b>;
    }
    return (
        <>
            {parameters.active != undefined && (
                <>
                    <b>Actives: </b> {parameters.active != "0" ? "Yes" : "No"} <br />{" "}
                </>
            )}
            {parameters.workWithMT != undefined && (
                <>
                    <b>Work with MT: </b> {parameters.workWithMT != "0" ? "Yes" : "No"} <br />
                </>
            )}
            {parameters.workOnHolidays != undefined && (
                <>
                    <b>Work on holidays:</b> {parameters.workOnHolidays != "0" ? "Yes" : "No"} <br />
                </>
            )}
            {parameters.readyToWork != undefined && (
                <>
                    <b>Ready to work:</b> {parameters.readyToWork != "0" ? "Yes" : "No"} <br />
                </>
            )}
            {parameters.campaign != undefined && (
                <>
                    <b>Campaign:</b> {parameters.campaign ? parameters.campaignName : "All"} <br />
                </>
            )}
            {parameters.tag != undefined && (
                <>
                    <b>Tag:</b> {parameters.tag ? parameters.tagName : "All"} <br />
                </>
            )}

            {parameters.priority != undefined && (
                <>
                    <b>Priority:</b> {parameters.priority ? parameters.priorityName : "All"} <br />
                </>
            )}
        </>
    );
};

const clientParameters = (parameters) => {
    if (Object.keys(parameters).length === 0) {
        return <b>No filters</b>;
    }
    return <b>No filters</b>;
};

const jobParameters = (parameters) => {
    if (Object.keys(parameters).length === 0) {
        return <b>No filters</b>;
    }
    return (
        <>
            {parameters.from != undefined && (
                <>
                    <b>From: </b> {Moment(parameters.from, DATE_DDMMYYYY).format(DATE_FORMAT)} <br />{" "}
                </>
            )}
            {parameters.to != undefined && (
                <>
                    <b>To: </b> {Moment(parameters.to, DATE_DDMMYYYY).format(DATE_FORMAT)} <br />{" "}
                </>
            )}
            {parameters.client != undefined && (
                <>
                    <b>Work on holidays:</b> {parameters.client != "0" ? parameters.clientName : "All"} <br />
                </>
            )}
            {parameters.unpaid != undefined && (
                <>
                    <b>Unpaid:</b> {parameters.unpaid != "0" ? "Yes" : "No"} <br />
                </>
            )}
            {parameters.status != undefined && (
                <>
                    <b>Ready to work:</b>
                    <ul>
                        {parameters.status.map((i) => (
                            <li>{i}</li>
                        ))}
                    </ul>
                </>
            )}
        </>
    );
};

const columnsAntd = (props) => {
    const { filters } = props;

    return [
        {
            title: "Type",
            dataIndex: "subtype",
            key: "subject",
            ...configureSort(filters.sort, filters.direction, "n.subtype"),
            ellipsis: true,
            // render: (name, record) => <Link to={LAYOUT_ADMIN_CAMPAIGN_EDIT(record.id)}>{name}</Link>,
        },
        {
            title: "Parameters",
            dataIndex: "parameters",
            key: "parameters",
            width: 250,
            render: (parameters, record) => {
                let parsed = {};

                if (parameters) {
                    parsed = JSON.parse(parameters);
                } else {
                    parsed = record.parameters_json || {};
                }
                if (record.subtype == CRON_REPORT_SUBTYPE_JOB) {
                    return jobParameters(parsed);
                } else if (record.subtype == CRON_REPORT_SUBTYPE_VENDOR) {
                    return vendorParameters(parsed);
                } else if (record.subtype == CRON_REPORT_SUBTYPE_CLIENT) {
                    return clientParameters(parsed);
                } else if (record.subtype == CRON_REPORT_SUBTYPE_PURCHASE_ORDER) {
                    return purchaseOrderParameters(parsed);
                } else if (record.subtype == CRON_REPORT_SUBTYPE_INVOICE) {
                    return invoiceParameters(parsed);
                } else if (record.subtype == CRON_REPORT_SUBTYPE_PAYMENT) {
                    return paymentParameters(parsed);
                } else if (record.subtype == CRON_REPORT_SUBTYPE_QA) {
                    return qaParameters(parsed);
                } else {
                    return (
                        <>
                            <b>no data</b>
                        </>
                    );
                }
            },
        },
        {
            title: "Created",
            dataIndex: "created_date",
            key: "created_date",
            ...configureSort(filters.sort, filters.direction, "n.createdDate"),
            width: 135,
            // eslint-disable-next-line react/display-name
            render: (value) => <DateTime value={value} />,
        },
        {
            title: "Modified",
            dataIndex: "modified_date",
            key: "modified_date",
            ...configureSort(filters.sort, filters.direction, "n.modifiedDate"),
            width: 135,
            // eslint-disable-next-line react/display-name
            render: (value) => <DateTime value={value} />,
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            align: "center",
            width: 150,
            render: (status, record) => {
                let color = "";
                if (status === "PENDING") {
                    color = "red";
                } else if (status === "PROCESSING") {
                    color = "orange";
                } else if (status === "PROCESSED") {
                    color = "green";
                } else {
                    color = "black";
                }
                return (
                    <Row justify="center">
                        <Tag style={{ margin: 0, lineHeight: "22px" }} color={color}>
                            {status}
                        </Tag>
                        {status === "PROCESSED" && (
                            <Button
                                style={{ margin: 0 }}
                                icon={<DownloadOutlined />}
                                size="small"
                                onClick={() => props.downloadExport(record.report, `R-${record.id}-${record.subtype}`)}
                            ></Button>
                        )}
                    </Row>
                );
            },
        },
        basicDeleteActionField({ remove: props.remove, loading: props.actionLoading }),
    ];
};

const Filters = (props) => {
    const { filters } = props;
    const report = filters ? (filters.subtype ? filters.subtype : undefined) : undefined;
    return (
        <Space size="small">
            <Select
                placeholder="Report"
                allowClear
                name="report"
                size="small"
                showSearch
                filterOption={_filter}
                style={{ minWidth: "150px" }}
                value={report}
                onChange={(e) => {
                    props.onUpdateFilters({ subtype: e ? e : undefined });
                }}
            >
                {CRON_REPORT_SUBTYPES.map((e) => (
                    <Option value={e}>{e}</Option>
                ))}
            </Select>
        </Space>
    );
};

const List = (props) => {
    const _goBack = () => {
        props.history.goBack();
    };

    const { data, meta, loading, filters } = props;

    const total = !loading && meta ? meta.total : 0;

    const pagination = {
        current: meta.current ? meta.current : "1",
        pageSize: meta.pageSize ? meta.pageSize : "20",
        total: meta.total ? meta.total : "0",
    };

    return (
        <>
            <BasicList
                titulo={"REPORTS EXPORTS (" + total + ")"}
                subtitulo="List"
                onPressBack={_goBack}
                textFilter={filters ? filters.text : ""}
                onPressNew={LAYOUT_REPORT_EXPORT_NEW}
            >
                <Filters {...props} />
                <Divider />

                <Table
                    bordered={true}
                    size="small"
                    rowKey={(row) => row.id}
                    dataSource={data}
                    columns={columnsAntd(props)}
                    loading={loading}
                    pagination={pagination}
                    onChange={props.handleTableChange}
                />
            </BasicList>
        </>
    );
};

export default List;
